import { useAsync } from "@react-hookz/web";
import { useEffect } from "react";

import { isValidUrl } from "shared/lib/utils";

import { useC2paContext } from "./contexts";
import {
  getCapturedOn,
  getCapturedWith,
  getFileCoin,
  getFlowNft,
  getGpsLocation,
  getIpfsContentId,
  getMedias,
  getProducedBy,
} from "./helpers";

export function useC2pa(input: string) {
  const c2paContext = useC2paContext();

  const [asyncState, { execute }] = useAsync(async () => {
    if (!c2paContext) return;
    const getViewMoreUrl = async () => {
      if (isValidUrl(input)) {
        const { ContentAuth } = await import("@contentauth/sdk");
        const parsedUrl = new URL(input);
        parsedUrl.searchParams.set("metadata", "keep");
        return ContentAuth.generateVerifyUrl(parsedUrl.toString());
      }
      return input;
    };
    const provenance = await c2paContext?.processImage(input);

    return {
      capturedOn: getCapturedOn(provenance),
      capturedWith: getCapturedWith(provenance),
      claims: await provenance.activeClaim?.asSerializableData(),
      fileCoin: getFileCoin(provenance.activeClaim),
      flowNft: getFlowNft(provenance.activeClaim),
      gpsLocation: getGpsLocation(provenance),
      ipfsContentId: getIpfsContentId(provenance.activeClaim),
      medias: getMedias(provenance.activeClaim),
      producedBy: getProducedBy(provenance, provenance.activeClaim),
      viewMoreUrl: await getViewMoreUrl(),
    };
  });

  useEffect(() => void execute(), [c2paContext, execute]);

  return asyncState?.result;
}
